import 'twin.macro'

import LogoutIcon from 'assets/icons/LogoutIcon'
import PersonalCabinetcon from 'assets/icons/PersonalCabinetcon'
import UserIcon from 'assets/icons/UserIcon'
import BodyText from 'components/UI/body-text/body-text'
import SubBody from 'components/UI/sub-body/sub-body'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  mobilePhoneSelector,
  openModalAfterBuySelector,
  setOpenModalAfterBuy
} from 'redux/store/slices/application-slice'
import { isAuthSelector } from 'redux/store/slices/auth-slice'
import { PURGE } from 'redux-persist'
import { pathnames } from 'utils/steps'

import AuthModal from './auth-modal'
function SignInButton() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false)
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const openModalAfterBuy = useSelector(openModalAfterBuySelector)

  const isAuthenticated = useSelector(isAuthSelector)
  const mobilePhone = useSelector(mobilePhoneSelector)

  const handleClose = () => {
    setOpen(false)
    dispatch(setOpenModalAfterBuy(false))
  }
  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleLogout = () => {
    window.open(pathnames.main, '_self')
    dispatch(setOpenModalAfterBuy(false))
  }

  useEffect(() => {
    openModalAfterBuy && setOpen(true)
  }, [openModalAfterBuy])

  return (
    <>
      <button
        tw='flex gap-2 items-center relative text-primary'
        onClick={!isAuthenticated ? handleOpenModal : () => setMenuOpen(!menuOpen)}
      >
        <div tw='w-[32px] h-[32px] bg-tertiary flex items-center justify-center rounded-full text-[#5C5C5C]'>
          <UserIcon />
        </div>
        {isAuthenticated ? <>{mobilePhone}</> : <SubBody variant='medium'>{t('sign_in', { ns: 'header' })}</SubBody>}
        {menuOpen && (
          <div tw='absolute bg-secondary w-[220px] top-12 rounded-s20 px-5 py-2 right-0 text-left text-s14'>
            <button tw='font-semibold flex gap-2 py-2 border border-l-0 border-t-0 border-r-0 items-center w-full'>
              <PersonalCabinetcon />
              {t('nav.cabinet', { ns: 'cabinet' })}
            </button>
            <button tw='font-semibold flex gap-2 py-2 items-center' onClick={handleLogout}>
              <LogoutIcon />
              {t('nav.sign_out', { ns: 'cabinet' })}
            </button>
          </div>
        )}
      </button>

      <AuthModal channel='auth' open={open} onClose={handleClose} />
    </>
  )
}

export default SignInButton
